/* eslint-disable no-underscore-dangle */
import {

  PerspectiveCamera,
  Vector3,

} from 'three';

import emitter from '@/scripts/stage/globals/emitter';

import { DEBUG, CONTROLS } from '@/scripts/stage/constants';

import gui from '@/scripts/stage/globals/gui';

class Camera extends PerspectiveCamera {
  constructor(fov, aspect, near, far) {
    super(fov, aspect, near, far);

    this.position.set(0, 0, 20);

    emitter.on('resize', this.resize.bind(this));

    this._offsetY = 0;

    this.lookAt(new Vector3(0, 0, 0));

    if (DEBUG) {
      if (CONTROLS) {
        this.addControls();
      }

      gui.add(this, '_offsetY', -2000, 2000)
        .step(0.01)
        .onChange(() => {
          this.setOffset();
        });

      gui.add(this.position, 'z', 0, 60)
        .step(0.01)
        .listen()
        .name('depth');
    }
  }

  setOffset(val = null) {
    if (val != null) {
      this._offsetY = val;
    }

    this.setViewOffset(
      this.w,

      this.h,

      0,

      this._offsetY,

      this.w,

      this.h,
    );
  }

  resize(w, h) {
    this.w = w;

    this.h = h;

    this.aspect = w / h;

    this.updateProjectionMatrix();
  }
}

export default new Camera(60, window.innerWidth / window.innerHeight, 1, 50);
